/**
 * Maps an object's properties to a questionAnswers dictionary where the property's key is the QuestionType and the
 * property's value is the answer. The property will be skipped if the value is null or undefined. The value will be
 * converted to a string.
 * @param {any} data The object containing the "QuestionType: answer" properties.
 */
export function objectToQuestionAnswers(data) {
    let questionAnswers = {};

    for (const [key, value] of Object.entries(data)) {
        if (
            value !== null &&
            value !== undefined
        ) {
            questionAnswers[key] = { answer: value.toString() }
        }
    }

    return questionAnswers;
}

/**
 * Gets the answer for the given QuestionType from the given interview.
 * @param {any} interview The interview containing the questionAnswers dictionary.
 * @param {string} questionType The QuestionType
 */
export function getAnswer(interview, questionType) {
    return interview?.questionAnswers?.[questionType]?.answer;
}

/**
 * Determines if the agency is a cobranded sub-agency by checking if
 * CobrandedNationalAccount has a non-empty value.
 * @param {Object|null|undefined} agencyInterview The agency interview object
 * @returns {boolean} True if the agency is a cobranded sub-agency, false otherwise
 */
export function isCobrandedSubAgency(agencyInterview) {
    const cobrandedNationalAccount = agencyInterview?.questionAnswers?.CobrandedNationalAccount?.answer;
    return !!cobrandedNationalAccount && cobrandedNationalAccount.trim() !== "";
}